import zozoFitRequester from "api/zozoFitRequester"
import {
  IBody,
  IBodyDisplayUnits,
  IManualUpdateGoalPayload,
} from "./profileTypes"

import requester from "api/requester"

const profileAPI = {
  getBody() {
    return zozoFitRequester.get("/v2/users/body")
  },

  getLatestUserScan() {
    return zozoFitRequester.get("/v2/users/measurements", {
      pageSize: 1,
      isArchived: false,
    })
  },

  getMeasurementById(measurementId: string) {
    return zozoFitRequester.get(`/v2/measurements/${measurementId}`)
  },

  updateBody(body: IBody) {
    return zozoFitRequester.put("/v2/users/body", body)
  },

  getBodyDisplayUnits() {
    return zozoFitRequester.get("/v2/display-settings")
  },

  updateBodyDisplayUnits(displayUnits: IBodyDisplayUnits) {
    return zozoFitRequester.put("/v2/display-settings", { displayUnits })
  },

  getProfile() {
    return zozoFitRequester.get(`/v2/users/profile`)
  },

  manualUpdateGoal(payload: IManualUpdateGoalPayload) {
    return requester.post(`/goal/customize`, payload)
  },
}

export default profileAPI
